import type React from 'react';
import { AppShell } from './components/AppShell';
import { ControlCenterProvider } from '@/pages/controlCenter';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type LayoutViewProps = {
    children: React.ReactNode;
    showBack: boolean;
    shouldWrapWithLayout: boolean;
};

export const LayoutView: React.FC<LayoutViewProps> = ({
    children,
    showBack,
    shouldWrapWithLayout,
}) => {
    if (!shouldWrapWithLayout) {
        return children;
    }

    return (
        <ControlCenterProvider>
            <div
                className="min-h-screen"
                {...getNodeTestIdProp('layout-container')}
                id="layout-container"
            >
                <AppShell showBack={showBack}>{children}</AppShell>
            </div>
        </ControlCenterProvider>
    );
};
